import styles from "./ServerIsDownMessage.module.scss";

function ServerIsDownMessage() {
  return (
    <div className={styles.background}>
      <div className={styles.errorMessageContainer}>
        <div className={styles.errorMessage}>
          Could not connect to server. Server is down or you may have internet connection issues. Try to refresh the page.
        </div>{" "}
      </div>
    </div>
  );
}

export default ServerIsDownMessage;
